// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB2b8yRDumnBcPMNoGspqVbxW9hohWKrlU",
  authDomain: "richiestabbonamenti-36b4e.firebaseapp.com",
  projectId: "richiestabbonamenti",
  storageBucket: "richiestabbonamenti.appspot.com",
  messagingSenderId: "956093615790",
  appId: "1:956093615790:web:410d8a9ad3b6b1673ea73f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

